import arrayMove from "array-move";
import { DateHelper } from "shared/helpers/DateHelper";
import { dueItemsSet } from "shared/itemLists/redux/itemListsSlice";
import { isInvalidTimeOrder } from "shared/itemLists/redux/caseLogic/timeValidationFunctions";
import {
  setTimeCorrectionObject,
  setMovingItem,
  updateItem,
} from "shared/itemLists/redux/itemListsSlice";
import { getActItems } from "shared/itemLists/redux/selectors/getActItems";
import { getCombinedItems, todayProps } from "../selectors/getCombinedItems";

export const moveItemCombinedAction = (payload) => (dispatch, getState) => {
  console.log("payload in moveItemCombinedAction: ", payload);
  const state = getState().itemLists;
  const { items, dueItems, today } = state;
  let isReschedulingDueItem = false;

  let dueItemsOffset = dueItems.length;
  let { oldIndex, newIndex, listType } = payload;
  if (oldIndex < dueItemsOffset && newIndex >= dueItemsOffset) {
    isReschedulingDueItem = true;
  } else {
    dueItemsOffset += 1;
  }
  if (payload.listType === "Act") {
    moveActItem(
      { ...payload, isReschedulingDueItem, dueItemsOffset },
      dispatch,
      getState
    );
    return;
  }
  const combinedItems = getCombinedItems(state);
  const oldIndexAbs = oldIndex;
  const newIndexAbs = newIndex;
  if (newIndex < dueItemsOffset && oldIndex < dueItemsOffset) {
    dispatch(dueItemsSet(arrayMove(dueItems, oldIndex, newIndex)));
    // this doesn't talk to backend... (missing feature)
    return;
  }

  // changes indexes to be the same as indexes in items (Rather than in the combination)
  if (newIndexAbs >= dueItemsOffset) {
    newIndex -= dueItemsOffset;
  }
  if (oldIndex >= dueItemsOffset) {
    oldIndex -= dueItemsOffset;
  }
  newIndex = findNewIndexBelowCalendarNotes(
    items,
    oldIndex,
    newIndex,
    isReschedulingDueItem
  );

  dispatch(
    setMovingItem({
      oldIndex,
      oldIndexAbs,
      newIndex,
      newIndexAbs,
      isReschedulingDueItem,
      listType,
    })
  );

  if (
    !isReschedulingDueItem &&
    isInvalidTimeOrder(combinedItems, oldIndexAbs, newIndexAbs)
  ) {
    dispatch(
      setTimeCorrectionObject({
        items: combinedItems,
        oldIndexAbs,
        newIndex,
        newIndexAbs,
        isOpen: true,
      })
    );
    return;
  }
  const oldItem = combinedItems[oldIndexAbs];
  if (isReschedulingDueItem && oldItem.time) {
    dispatch(
      updateItem({
        attributes: { time: null },
        id: oldItem.id,
        isDueItem: true,
        method: { type: "index", index: oldIndexAbs },
      })
    );
  }
  dispatch(finishMovingItem());
};

function moveActItem(payload, dispatch, getState) {
  const { isReschedulingDueItem, dueItemsOffset, newIndex, oldIndex } = payload;

  const state = getState().itemLists;

  let oldPlanIndex = oldIndex;
  let incrementor = oldIndex > newIndex ? 1 : 0;
  const actItems = state.dueItems.concat(
    [todayProps(state.today)].concat(getActItems(state))
  );
  const beforeItem = actItems[newIndex - incrementor];
  const oldId = getOldId({
    isReschedulingDueItem,
    dueItems: state.dueItems,
    mainItems: actItems,
    oldIndex,
  });
  if (!isReschedulingDueItem) {
    oldPlanIndex =
      state.items.findIndex((item) => item.id === oldId) + dueItemsOffset;
  }
  let newPlanIndex;

  if (beforeItem.day_name === "Today") {
    newPlanIndex = dueItemsOffset;
  } else if (beforeItem.day_name === "Ahead") {
    newPlanIndex =
      state.items.findIndex((item) => item.day === beforeItem.day) +
      incrementor +
      dueItemsOffset;
  } else {
    newPlanIndex =
      state.items.findIndex((item) => item.id === beforeItem.id) +
      incrementor +
      dueItemsOffset;
  }
  if (isReschedulingDueItem) {
    newPlanIndex += 1;
  }

  const newPayload = {
    ...payload,
    newIndex: newPlanIndex,
    oldIndex: oldPlanIndex,
    listType: "Plan",
  };
  dispatch(moveItemCombinedAction(newPayload));
}

export const finishMovingItem = (payload) => (dispatch, getState) => {
  const { movingItem } = getState().itemLists;
  const effect = () => {
    const movingItem = getState().itemLists.movingItem;
    return {
      url: "items",
      id: movingItem.id,
      json: {
        day: movingItem.newDay,
        on_day_index: movingItem.onDayIndex,
      },
      method: "PATCH",
    };
  };
  dispatch({
    type: "itemLists/moveItem",
    payload: movingItem,
    meta: {
      offline: {
        effect: effect,
        commit: { type: "itemLists/moveItem.commit" },
      },
    },
  });
};

export function moveItemCaseLogic(state, action) {
  if (getItemType(state, action.payload.oldIndex) === "calendar_note") {
    moveCalendarNote(state, action);
  }
  movePlanItemCaseLogic(state, action);
}

function movePlanItemCaseLogic(state, action) {
  const { oldIndex, newIndex, isReschedulingDueItem } = action.payload;
  const dateHelper = new DateHelper(state.today);
  const { dueItems, items } = state;
  state.movingItem.newDay = getNewDay(
    dateHelper,
    items,
    oldIndex,
    newIndex,
    isReschedulingDueItem
  );
  state.movingItem.id = getOldId({
    mainItems: items,
    ...{ isReschedulingDueItem, dueItems, oldIndex },
  });
  if (isReschedulingDueItem) {
    rescheduleDueItem({ state, action });
  } else {
    state.items = arrayMove(items, oldIndex, newIndex);
  }
  state.items[newIndex].day = state.movingItem.newDay;
  state.movingItem.onDayIndex = getOnDayIndex(state.items, newIndex);
  state.items[newIndex].on_day_index = state.movingItem.onDayIndex;
}

function getItemType(state, index) {
  return state.items[index].type;
}

function moveCalendarNote(state, action) {
  state.items[action.payload.oldIndex].isPending = true;
  state.needsReload = true;
}

function getOldId({ isReschedulingDueItem, dueItems, mainItems, oldIndex }) {
  if (isReschedulingDueItem) {
    return dueItems[oldIndex].id;
  } else {
    return mainItems[oldIndex].id;
  }
}

function rescheduleDueItem({ state, action }) {
  const { oldIndexAbs, newIndex } = action.payload;
  const { dueItems, items } = state;
  const i = oldIndexAbs;
  const j = newIndex;
  const updatedItem = { ...dueItems[i] };
  state.dueItems = dueItems.filter((item) => item.id !== state.movingItem.id);
  items.splice(j, 0, updatedItem);
}

function getNewDay(
  dateHelper,
  items,
  oldIndex,
  newIndex,
  isReschedulingDueItem = false
) {
  if (oldIndex <= newIndex && !isReschedulingDueItem) {
    return items[newIndex].day;
  } else if (newIndex === 0) {
    return dateHelper.getDateString();
  } else {
    return items[newIndex - 1].day;
  }
}

function getOnDayIndex(items, i) {
  let onDayIndex = 0;
  while (i > 0) {
    let typeAbove = items[i - 1].type;
    if (
      typeAbove === "day_name" ||
      typeAbove === "calendar_note" ||
      typeAbove === "continuing_calendar_note"
    ) {
      return onDayIndex;
    }
    onDayIndex++;
    i--;
  }
  return onDayIndex;
}

function findNewIndexBelowCalendarNotes(
  items,
  oldIndex,
  newIndex,
  isReschedulingDueItem = false
) {
  const offset = !isReschedulingDueItem && newIndex > oldIndex ? 1 : 0;
  let i = newIndex;
  while (i + offset < items.length) {
    if (
      items[i + offset].type !== "calendar_note" &&
      items[i + offset].type !== "continuing_calendar_note"
    ) {
      return i;
    } else {
      i++;
    }
  }
  return i;
}
